export default __webpack_public_path__ + "static/partnerColorIcon21-df87b5d0585c8cf42bb14ed04691bc7c.svg";